import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-loan-timeline-static',
  templateUrl: './loan-timeline-static.component.html',
  styleUrls: ['./loan-timeline-static.component.scss']
})
export class LoanTimelineStaticComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal = '';

  ngOnInit() {
    const modal = this.globals.getModalValue();
    if (undefined !== modal) {
      this.section_modal = modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }

}
